import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { handleAuthCallback } from "../utils/auth";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    handleAuthCallback(navigate);
  }, [navigate]);

  return <div style={{ padding: 40 }}>Login Callback...</div>;
}
